/**
 * Get statistics about categories in metadata
 * @param metadata - Array of metadata objects
 * @param options - Options for categorization
 * @returns Object with category statistics
 */
export function getCategoriesStats(metadata, options = {}) {
    const { propertyName = 'category' } = options;
    const categories = {};
    let classNumber = 0;
    for (const metadatum of metadata) {
        const value = metadatum[propertyName];
        if (!categories[value]) {
            categories[value] = {
                classNumber: classNumber++,
                counter: 0,
            };
        }
        categories[value].counter++;
    }
    return categories;
}
//# sourceMappingURL=getCategoriesStats.js.map